import styled, { css } from 'styled-components';

import { Menu, MenuButton, MenuItems, MenuItem, MenuPopover, MenuLink } from '@reach/menu-button';

import {
  primaryButtonStyles,
  secondaryButtonStyles,
  tertiaryButtonStyles,
  IconWrapper,
  LabelWrapper,
} from '../button/index.styles';

import { popoverStyles } from '../select/index.styles';

const shouldForwardProp = (prop) => !['hasLabel'].includes(prop);

export const Wrapper = styled(Menu)``;

export const Button = styled(MenuButton).withConfig({ shouldForwardProp })`
  ${(props) =>
    (() => {
      switch (props.variant) {
        case 'primary':
          return primaryButtonStyles;
        case 'secondary':
          return secondaryButtonStyles;
        case 'tertiary':
        default:
          return tertiaryButtonStyles;
      }
    })()}}
`;

export const ButtonIconWrapper = IconWrapper;

export const ButtonLabelWrapper = LabelWrapper;

export const Popover = styled(MenuPopover)``;

export const List = styled(MenuItems)`
  ${popoverStyles}
  min-width: 256px;
`;

export const ItemIconWrapper = styled.div`
  line-height: 0;
  color: ${(props) => (props.variant === 'destructive' ? 'inherit' : 'var(--coolGray-500)')};
`;

const itemStyles = css`
  display: flex;
  gap: 8px;
  padding: 8px;
  white-space: nowrap;
  user-select: none;
  color: ${(props) =>
    props.variant === 'destructive' ? 'var(--pink-900)' : 'var(--coolGray-700)'};
  cursor: pointer;

  &[data-selected],
  &:hover,
  &:focus {
    background-color: var(--coolGray-100);
    color: ${(props) =>
      props.variant === 'destructive' ? 'var(--pink-900)' : 'var(--coolGray-700)'};
    text-decoration: none;

    ${ItemIconWrapper} {
      color: ${(props) => (props.variant === 'destructive' ? 'inherit' : 'var(--coolGray-700)')};
    }
  }
`;

export const Item = styled(MenuItem)`
  ${itemStyles}
`;

export const Link = styled(MenuLink)`
  ${itemStyles}
`;

export const ItemLabelWrapper = styled.div``;
